import React from "react";

import { ProductVisibilityTypes } from "@utils/enums";

import { ECommerceProduct, EDLPImage } from "../eCommerce.types";
import Cashback from "./cashback/cashback.component";
import Conversion from "./conversion/conversion.component";
import Discount from "./discount/discount.component";
import EveryDayLowPrice from "./everyDayLowPrice/everyDayLowPrice.component";
import Promotion from "./promotion/promotion.component";
import RecupelIncluded from "./recupelIncluded/recupelIncluded.component";
import WebOnly from "./webOnly/webOnly.component";

type Props = {
    visibilityType?: ProductVisibilityTypes;
    discountPercentage?: number;
    cashbackAmount?: number | null;
    cashbackUnit?: string | null;
    priceAfterCashbackIsApplied: number | null;
    strikethroughPrice: number | null;
    conversionUnit: string | null;
    currentPrice: number | null;
    strikethroughConversionPrice: number | null;
    currentConversionPrice: number | null;
    product: ECommerceProduct;
    isEveryDayLowPrice: boolean;
    eDLPImage: EDLPImage;
    webOnly: boolean;
};

const Pricing = ({
    visibilityType,
    discountPercentage,
    cashbackAmount,
    cashbackUnit,
    priceAfterCashbackIsApplied,
    currentPrice,
    strikethroughPrice,
    currentConversionPrice,
    strikethroughConversionPrice,
    conversionUnit,
    product,
    isEveryDayLowPrice,
    eDLPImage,
    webOnly,
}: Props) => {
    if(!currentPrice){
        return null;
    }
    
    return visibilityType !== ProductVisibilityTypes.NotAvailable ? (
        <>
            <div className="d-flex">
                <div className="col-8">
                    <WebOnly show={webOnly} />
                    <Discount
                        discountPercentage={discountPercentage}
                        product={product}
                    />
                    <Cashback
                        cashbackAmount={cashbackAmount}
                        cashbackUnit={cashbackUnit}
                        priceAfterCashbackIsApplied={
                            priceAfterCashbackIsApplied
                        }
                    />
                    {isEveryDayLowPrice && (
                        <EveryDayLowPrice image={eDLPImage} />
                    )}
                </div>
                <div className="col-4">
                    <Promotion
                        product={product}
                        conversionUnit={conversionUnit}
                        strikethroughPrice={strikethroughPrice}
                        currentPrice={currentPrice}
                        currentConversionPrice={currentConversionPrice}
                        strikethroughConversionPrice={
                            strikethroughConversionPrice
                        }
                    />
                    <Conversion
                        showConvertedPriceAsMainPrice={
                            !!product.showConvertedPriceAsMainPrice
                        }
                        currentConversionPrice={currentConversionPrice}
                        conversionUnit={conversionUnit}
                        currentPrice={currentPrice}
                    />
                    {!!product.recupel && product.recupel > 0 && (
                        <RecupelIncluded />
                    )}
                </div>
            </div>
        </>
    ) : (
        <></>
    );
};

export default Pricing;
